const language = {
  props: {
    dynamicClass: ".c-ribbon-language.dynamicLoading",
    classNameClose: "ribbon-close-btn-JS",
    localStorageName: "languageRibbon",
    nameAttrIndex: "data-index",
    resolveRibbonLanguage: null,
    open: false,
  },

  init: function (baseDom, data) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-ribbonLanguage.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document;

    if (!this.props.open) {
      bcl.c.header.language.initDialog(!!data);
      if (this.props.open) {
        this.initNodes(baseFind, !!data);
        bcl.c.languageDialog.update(data);
      }
    }
  },

  initNodes: function (baseFind, forceOpen) {
    bcl.u.forEach(baseFind.getElementsByClassName("ribbon-language ribbon"), ($element) => {
      if (bcl.u.containsClass($element, bcl.c.ribbon.props.classNameShow)) {
        return;
      }

      this.searchNodesForClose($element, this.clickClose.bind(this));

      if (bcl.editMode || (bcl.c.ribbon.isValid($element) && (forceOpen || !localStorage.getItem(this.getNameAttr())))) {
        bcl.u.addClass($element, bcl.c.ribbon.props.classNameShow);
      }
    });

    bcl.u.forEach(baseFind.querySelectorAll("main.root > div .parsys .ribbon-language.ribbon"), ($element) => {
      this.searchNodesForClose($element, bcl.c.ribbon.clickCloseDeleteMarginHeader.bind(bcl.c.ribbon));

      const index = bcl.s.sticky.add(
        {
          $node: $element,
          callbackValid: bcl.c.ribbon.isValid.bind(bcl.c.ribbon),
          inHeader: true,
        },
        true,
      );

      $element.setAttribute(bcl.c.ribbon.props.nameAttrIndex, index);
    });
  },

  clickClose: function (e) {
    const $ribbon = e.target.closest(".ribbon");

    if ($ribbon) {
      bcl.u.removeClass($ribbon, bcl.c.ribbon.props.classNameShow);
      localStorage.setItem(this.getNameAttr(), new Date());
    }
  },

  searchNodesForClose: function ($element, callback) {
    const $closeBtns = $element.getElementsByClassName(this.props.classNameClose);

    bcl.u.forEach($closeBtns, ($closeBtn) => {
      $closeBtn.addEventListener("click", callback);
    });
  },

  getNameAttr: function () {
    return "barcelo_" + this.props.localStorageName;
  },
};

if (!window.bcl) {
  window.bcl = {};
}
if (!window.bcl.c) {
  window.bcl.c = {};
}
window.bcl.c.language = language;

export default language;
